import type { ProductVariantDto } from "../../../../api";
import { QuantitySelector } from "../../../../components/forms/quantity-selector";
import { AddToCartButton } from "./add-to-cart-button";

interface ProductActionsProps {
  product: ProductVariantDto;
  quantity: number;
  onQuantityChange: (quantity: number) => void;
  availableQuantity: number;
}

export function ProductActions({
  product,
  quantity,
  onQuantityChange,
  availableQuantity,
}: ProductActionsProps) {
  return (
    <div className="flex items-center gap-4">
      <QuantitySelector
        value={quantity}
        onChange={onQuantityChange}
        min={1}
        max={availableQuantity > 0 ? availableQuantity : undefined}
        disabled={availableQuantity === 0}
      />
      <div className="flex-1">
        <AddToCartButton
          product={product}
          quantity={quantity}
          size="md"
          fullWidth
        />
      </div>
    </div>
  );
}
